class BulkTrackUploadManager {
  constructor({ localeGetter }) {
    this.localeGetter = localeGetter || function () { return 'en'; };
  }

  initDropareas() {
    const dropzones = document.querySelectorAll('[data-bulk-track-dropzone]');

    if (!dropzones.length) {
      return;
    }

    dropzones.forEach((dropzone) => {
      const form = dropzone.closest('form');
      const picker = dropzone.querySelector('[data-bulk-track-file-picker]');
      const feedback = dropzone.querySelector('[data-bulk-track-picker-feedback]');

      if (!form || !picker) {
        return;
      }

      dropzone.addEventListener('click', (event) => {
        if (event.target === picker) {
          return;
        }
        picker.click();
      });

      picker.addEventListener('change', (event) => {
        this.enqueueFiles(form, event.target.files, feedback);
        event.target.value = '';
      });

      dropzone.addEventListener('dragover', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) {
          event.dataTransfer.dropEffect = 'copy';
        }
        dropzone.classList.add('is-dragover');
      });

      dropzone.addEventListener('dragenter', (event) => {
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.add('is-dragover');
      });

      dropzone.addEventListener('dragleave', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (event.target === dropzone) {
          dropzone.classList.remove('is-dragover');
        }
      });

      dropzone.addEventListener('drop', (event) => {
        event.preventDefault();
        event.stopPropagation();
        dropzone.classList.remove('is-dragover');
        if (event.dataTransfer && event.dataTransfer.files) {
          this.enqueueFiles(form, event.dataTransfer.files, feedback);
        }
      });
    });
  }

  initSorting() {
    if (typeof sortable === 'undefined') {
      return;
    }

    const lists = document.querySelectorAll('[data-position-sortable-list]');
    if (!lists.length) {
      return;
    }

    lists.forEach((list) => {
      // Ensure newly added nested fields become draggable as well.
      sortable(list, {
        items: '.fields',
        handle: '[data-position-sort-handle]'
      });

      this.ensureHandleDataAttributes(list);

      if (list.dataset.positionSortableBound !== '1') {
        list.addEventListener('sortupdate', () => {
          this.syncPositions(list);
        });
        list.dataset.positionSortableBound = '1';
      }

      this.syncPositions(list);
    });
  }

  ensureHandleDataAttributes(list) {
    const handles = list.querySelectorAll('.sortable-handle');
    handles.forEach((handle) => {
      if (!handle.dataset.positionSortHandle) {
        handle.dataset.positionSortHandle = 'true';
      }
    });
  }

  syncPositions(list) {
    const children = Array.prototype.slice.call(list.children || []);
    let nextPosition = 1;

    children.forEach((child) => {
      if (!child.classList || !child.classList.contains('fields')) {
        return;
      }

      if (child.offsetParent === null) {
        return;
      }

      const destroyInput = child.querySelector('input[type="hidden"][name$="[_destroy]"]');
      if (destroyInput && destroyInput.value === '1') {
        return;
      }

      const positionInput = child.querySelector('input[name$="[position]"]');
      if (!positionInput) {
        return;
      }

      positionInput.value = nextPosition;
      nextPosition += 1;
    });
  }

  prepareAddData({ bulkUploadMode, data, formElement }) {
    if (!bulkUploadMode || !data || !data.originalFiles || data.originalFiles.length <= 1) {
      return;
    }

    const allFiles = Array.prototype.slice.call(data.originalFiles);
    const firstFile = allFiles.shift();
    if (allFiles.length > 0) {
      this.enqueueFiles(formElement, allFiles);
    }

    data.files = [firstFile];
    data.originalFiles = [firstFile];
  }

  releaseAssignedInput(fileInputElement, bulkUploadMode) {
    if (bulkUploadMode && fileInputElement) {
      fileInputElement.dataset.bulkAssigned = '';
    }
  }

  consumePendingForField(fieldElement) {
    const form = fieldElement && fieldElement.closest('form');
    const queue = form && form._bulkTrackFilesQueue;

    if (!form || !queue || !queue.length) {
      return;
    }

    const input = fieldElement.querySelector('input[type="file"][data-bulk-track-file-input]');
    if (!input) {
      form._bulkTrackAddingField = false;
      this.flushQueue(form);
      return;
    }

    const nextFile = queue.shift();
    this.assignFileToInput(input, nextFile);
    form._bulkTrackAddingField = false;
    this.flushQueue(form);
  }

  enqueueFiles(form, files, feedbackElement) {
    const filesArray = Array.prototype.slice.call(files || []);

    if (!filesArray.length) {
      return;
    }

    const queuedFiles = (form._bulkTrackFilesQueue || []);
    filesArray.forEach((file) => { queuedFiles.push(file); });
    form._bulkTrackFilesQueue = queuedFiles;
    this.flushQueue(form);

    if (feedbackElement) {
      const locale = this.localeGetter();
      feedbackElement.textContent = (locale === 'de' ?
        (filesArray.length + ' Datei(en) zur Upload-Warteschlange hinzugefügt.') :
        (filesArray.length + ' file(s) added to upload queue.'));
    }
  }

  flushQueue(form) {
    const queue = form && form._bulkTrackFilesQueue;

    if (!form || !queue || !queue.length) {
      if (form) {
        form._bulkTrackAddingField = false;
      }
      return;
    }

    const nextInput = this.findNextEmptyInput(form);
    if (nextInput) {
      this.assignFileToInput(nextInput, queue.shift());
      setTimeout(() => {
        this.flushQueue(form);
      }, 0);
      return;
    }

    if (form._bulkTrackAddingField) {
      return;
    }

    const addButton = this.findAddButton(form);
    if (!addButton) {
      return;
    }

    form._bulkTrackAddingField = true;
    $(addButton).trigger('click');

    setTimeout(() => {
      if (!form._bulkTrackAddingField) {
        return;
      }
      form._bulkTrackAddingField = false;
      this.flushQueue(form);
    }, 300);
  }

  findAddButton(form) {
    return form.querySelector('[data-bulk-track-upload-add]') ||
      form.querySelector('[data-association*="bulk_track_upload"]') ||
      form.querySelector('a.add_nested_fields[data-association="bulk_track_uploads"]') ||
      form.querySelector('a.add_nested_fields') ||
      form.querySelector('a[data-association]');
  }

  findNextEmptyInput(form) {
    const inputs = form.querySelectorAll('input[type="file"][data-bulk-track-file-input]');

    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].dataset.bulkAssigned === '1') {
        continue;
      }
      if (inputs[i].files && inputs[i].files.length > 0) {
        continue;
      }
      if (inputs[i].offsetParent === null) {
        continue;
      }
      return inputs[i];
    }

    return null;
  }

  assignFileToInput(input, file) {
    if (!input || !file || typeof DataTransfer === 'undefined') {
      return;
    }

    const fieldRow = input.closest('.fields');
    const currentPositionInput = fieldRow ? fieldRow.querySelector('input[name$="[position]"]') : null;
    const formerPositionInput = fieldRow && fieldRow.previousElementSibling ? fieldRow.previousElementSibling.querySelector('input[name$="[position]"]') : null;

    if (currentPositionInput && currentPositionInput.value.length === 0) {
      if (formerPositionInput && formerPositionInput.value.length > 0) {
        currentPositionInput.value = parseInt(formerPositionInput.value, 10) + 1;
      } else {
        currentPositionInput.value = 1;
      }
    }

    input.dataset.bulkAssigned = '1';
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    input.files = dataTransfer.files;
    $(input).trigger('change');
  }
}

export default BulkTrackUploadManager;
